import { Box, Typography } from "@mui/joy";
import { Controller, useFormContext } from "react-hook-form";
import { TextField } from "../../../../../shared";
import { Switch as JoySwitch } from "@mui/joy";

export function OrganizationConfiguration() {
    const { control } = useFormContext();

    return (
        <Box flex={1}>
            <Box mt={2} display={"flex"} flexDirection={"column"} gap={1}>
                <TextField
                    name={"Name"}
                    label={"Organization Name"}
                    helperText={"Enter the name of the organization"}
                    placeholder={"e.g., Colorado Roofing Company"}
                />

                <Box mt={2}>
                    <Typography level="body-sm" sx={{ mb: 1, fontWeight: 500 }}>
                        Active Status
                    </Typography>
                    <Controller
                        name="IsActive"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <JoySwitch
                                checked={value}
                                onChange={(event) => onChange(event.target.checked)}
                                sx={{
                                    "--Switch-thumbSize": "16px",
                                    "--Switch-trackWidth": "36px",
                                    "--Switch-trackHeight": "20px",
                                }}
                            />
                        )}
                    />
                </Box>
            </Box>
        </Box>
    );
}
